import { render, staticRenderFns } from "./Sun.vue?vue&type=template&id=756f6c74&scoped=true"
import script from "./Sun.vue?vue&type=script&lang=js"
export * from "./Sun.vue?vue&type=script&lang=js"
import style0 from "./Sun.vue?vue&type=style&index=0&id=756f6c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f6c74",
  null
  
)

export default component.exports